
















import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import {
  InsertFollowMessage,
  UpdateFollowMessage
} from "@/api/follow/followMessage";
@Component({})
export default class FollowMessageDetail extends AbpBase {
  @Prop() data: any;
  model: any = {};
  rules = {
    name: [{ required: true, message: "请输入内容", trigger: "blur" }],
    content: [{ required: true, message: "请输入内容", trigger: "blur" }]
  };

  @Watch("data", { immediate: true })
  onDataChanged() {
    this.model = this.data;
  }

  resetForm() {
    this.$refs.form.resetFields();
  }

  async submit() {
    let validResult = false;
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      if (this.model.id) {
        await UpdateFollowMessage(this.model);
      } else {
        await InsertFollowMessage(this.model);
      }
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followMessage/detail.vue